import axios from 'axios';
import config from '../helpers/configProvider';

export default () => {
  return axios.create({
    baseURL:
      config.getEnv(config.enum.VUE_APP_DB_SERVICE_URL) || `https://demo.mapcat.com/featuredb/api`
  });
};
